import { useState } from "react";

function HeroManParallax() {
  const [mainImageLoaded, setMainImageLoaded] = useState(false);

  return (
    <div className="hero-man-parallax">
      <img 
        src={`${process.env.PUBLIC_URL}/images/hero_man.svg`} 
        alt="Tax filing professional" 
        className="hero-image-main"
        onLoad={() => setMainImageLoaded(true)}
      />
      {mainImageLoaded && (
        <>
          <img 
            src={`${process.env.PUBLIC_URL}/images/process_workflow.svg`} 
            alt="Process workflow" 
            className="hero-image-complement hero-image-workflow"
          />
          <img 
            src={`${process.env.PUBLIC_URL}/images/tracking_status.svg`} 
            alt="Tracking status" 
            className="hero-image-complement hero-image-tracking"
          />
        </>
      )}
    </div>
  );
}

export default HeroManParallax;

